export enum UPLOADTYPE {
  PDF = "PDF",
  VIDEO = "VIDEO",
  IMAGES = "IMAGES",
  LINK = "LINK",
}
